export default __webpack_public_path__ + "static/media/driverimage.56b21195.jpeg";